export const initialState: IAuthState = {
  isLogin: false,
  user: {},
  userRoleActions: []
};
